// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"Styles_checkboxWrapper__248w7","itemName":"Styles_itemName__3-VwG","inputField":"Styles_inputField__pY6I1"};